export default __webpack_public_path__ + "static/media/gallery_07.9ec6a50d.jpg";